import React from 'react'
import HeroUpdated from './HeroUpdated';
// import About from './About';
import Services from './Services';
// import Contact from './Contact';
import Footer from './Footer';
// import Team from './Team';
import Copyright from './Copyright';
import AboutUpdated from './AboutUpdated';
import ContactUpdated from './ContactUpdated';

const Home = () => {
  return (
    <div className='bg-[#f4f7fb]'>
        <HeroUpdated />
        <AboutUpdated />
        <Services />
        <ContactUpdated />
        <Footer />
        <Copyright />
    </div>
  )
}

export default Home;